import $ from 'jquery'

const Notification = (($) => {

	class Notification {

		constructor(title, message, type, show){
			this._element = document.createElement('div')
			this._element.classList.add('ion-notification')

			if(title){
				let titleBox = document.createElement('h5')
				titleBox.innerText = title
				this._element.appendChild(titleBox)
			}
			if(message){
				let messageBox = document.createElement('div')
				messageBox.innerText = message
				this._element.appendChild(messageBox)
			}

			if(type){
				this._element.classList.add('ion-notification-' + type)
			}

			if(show){
				this.show()
			}
		}

		show(timeout){
			const self = this

			timeout = timeout || 2000

			document.body.appendChild(this._element);
			setTimeout(() => {
				self.hide()
			}, timeout)
		}

		hide(){
			const self = this

			$(this._element).animate({
				opacity: 0.10
			}, 1000, () => {
				self.remove()
			})
		}

		remove(){
			document.body.removeChild(this._element)
		}
	}

	return Notification
})($)

export default Notification
